import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IBannerService = ( createDecorator('bannerService'));
export { IBannerService };
